import axios from 'axios';
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, USE_BEARER } from '../../constants';
import { setAuthorizedEvent } from '../../App';
import { BASE_URL } from './axiosInstances';

export const createAxiosInstance = (baseURL, options = {}) => {
  const axiosRequest = axios.create({
    baseURL,
    ...options,
  });
  const axiosRaw = axios.create({ baseURL: BASE_URL }); // для обновления токена

  axiosRequest.interceptors.request.use(async (req) => {
    if (!req._auth) return req;
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    if (USE_BEARER && token) {
      req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
  });
  axiosRequest.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      let authTokens = {
        access: localStorage.getItem(ACCESS_TOKEN_KEY),
        refresh: localStorage.getItem(REFRESH_TOKEN_KEY),
      };
      if (error.response?.status === 401 && !originalRequest._retry && originalRequest._auth && authTokens.refresh) {
        originalRequest._retry = true;
        try {
          const refreshResponse = await axiosRaw.post('auth/refresh', { refresh_token: authTokens.refresh });
          const { access_token, refresh_token } = refreshResponse.data;
          localStorage.setItem(ACCESS_TOKEN_KEY, access_token);
          localStorage.setItem(REFRESH_TOKEN_KEY, refresh_token);
          setAuthorizedEvent(true);
          originalRequest.headers.Authorization = `Bearer ${access_token}`;
          return axiosRequest(originalRequest);
        } catch (refreshError) {
          localStorage.removeItem(ACCESS_TOKEN_KEY);
          localStorage.removeItem(REFRESH_TOKEN_KEY);
          setAuthorizedEvent(false);
          return Promise.reject(refreshError);
        }
      }
      return Promise.reject(error);
    }
  );

  return axiosRequest;
};
